module.exports = __webpack_public_path__ + "img/game_icon_yellow.fa7d930a.png";